import React, { type ReactElement, useEffect } from 'react';
import toast from 'react-hot-toast';
import { useLocation } from 'react-router';

import { CSSObject, css } from '@emotion/react';
import styled from '@emotion/styled';

export interface ToastProps {
  icon?: ReactElement;
  message: React.ReactNode;
  id?: string;
  $isSuccess: boolean;
  $shape: 'long' | 'short' | 'top-center';
  $duration: number;
  $style?: CSSObject;
}

function Toast(props: ToastProps) {
  const { icon, message, $isSuccess, $shape, $duration, $style } = props;
  const { pathname } = useLocation();

  useEffect(() => {
    toast.remove();
  }, [pathname]);

  return (
    <SToastWrapper $isSuccess={$isSuccess} $shape={$shape} $duration={$duration} $style={$style}>
      {icon}
      {message}
    </SToastWrapper>
  );
}

export default Toast;

const SToastWrapper = styled.div<Pick<ToastProps, '$isSuccess' | '$shape' | '$duration' | '$style'>>`
  ${({ theme, $isSuccess, $shape, $duration, $style }) => {
    return css`
      display: flex;
      justify-content: center;
      align-items: center;
      color: ${theme.color.static.white};
      background-color: ${$isSuccess ? theme.color.static.primary : theme.color.static.warning};
      ${$shape === 'long'
        ? css`
            width: 100vw;
            height: 60px;
            animation: slideIn 0.5s;
          `
        : css`
            min-width: 200px;
            height: 50px;
            margin-bottom: 20vh;
            border-radius: 10px;
            opacity: 0;
            animation: fade ${$duration}ms;
          `};

      // icon
      svg {
        margin-right: 4px;
        &.whiteCheckIcon {
          width: 16px;
          path {
            fill: white !important;
          }
        }
      }

      // message
      div {
        margin: 4px 0 0 0;
      }

      @keyframes slideIn {
        from {
          margin-top: -60px;
        }
        to {
          margin-top: 0;
        }
      }

      @keyframes fade {
        20% {
          opacity: 1;
        }
        80% {
          opacity: 1;
        }
        100% {
          opacity: 0;
        }
      }

      ${$style}
    `;
  }};
`;
